/* =============================================================
   Davila Paternal — Interações da página comemorativa
   - Scroll suave nos botões âncora
   - Marca botão ativo conforme scroll passa por cada section
   ============================================================= */
(function () {
  'use strict';

  function setupSmoothScroll() {
    var anchors = document.querySelectorAll('[data-paternal-anchor]');
    anchors.forEach(function (anchor) {
      if (anchor.dataset.davilaPaternalInit === '1') return;
      anchor.dataset.davilaPaternalInit = '1';

      anchor.addEventListener('click', function (e) {
        var href = anchor.getAttribute('href') || '';
        if (!href.startsWith('#') || href.length < 2) return;

        var target = document.getElementById(href.slice(1));
        if (!target) return;

        e.preventDefault();
        // compensa header fixo (~90px)
        var offset = 90;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });

        // marca como ativo imediatamente (visual feedback)
        anchors.forEach(function (a) { a.classList.remove('is-active'); });
        anchor.classList.add('is-active');
      });
    });
  }

  function setupScrollSpy() {
    var anchors = document.querySelectorAll('[data-paternal-anchor]');
    if (!anchors.length) return;

    var targets = [];
    anchors.forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (!href.startsWith('#') || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (target) targets.push({ anchor: anchor, target: target });
    });

    if (!targets.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var matched = targets.find(function (t) { return t.target === entry.target; });
        if (!matched) return;
        anchors.forEach(function (a) { a.classList.remove('is-active'); });
        matched.anchor.classList.add('is-active');
      });
    }, {
      rootMargin: '-30% 0px -60% 0px',
      threshold: 0
    });

    targets.forEach(function (t) { observer.observe(t.target); });
  }

  function formatMoneyBRL(cents, prefix) {
    var reais = (cents / 100).toFixed(2).replace('.', ',');
    var parts = reais.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (prefix || 'R$') + ' ' + parts.join(',');
  }

  function updateProgressBar(progressEl, cartTotalCents) {
    var goal = parseInt(progressEl.dataset.progressGoalCents, 10);
    var prefix = progressEl.dataset.progressPrefix || 'R$';
    var beforeText = progressEl.dataset.progressBefore || '';
    var reachedText = progressEl.dataset.progressReached || '';
    var reached = cartTotalCents >= goal;

    progressEl.classList.toggle('davila-paternal-progress--reached', reached);

    var fill = progressEl.querySelector('[data-paternal-progress-fill]');
    if (fill) {
      var percent = Math.min(100, Math.round((cartTotalCents / goal) * 100));
      fill.style.width = percent + '%';
    }

    var textEl = progressEl.querySelector('[data-paternal-progress-text]');
    if (textEl) {
      if (reached) {
        textEl.textContent = reachedText;
      } else {
        var missing = goal - cartTotalCents;
        textEl.textContent = beforeText.replace('[valor]', formatMoneyBRL(missing, prefix));
      }
    }

    var currentEl = progressEl.querySelector('[data-paternal-progress-current]');
    if (currentEl) {
      currentEl.textContent = formatMoneyBRL(cartTotalCents, prefix);
    }
  }

  function fetchCartAndUpdate() {
    // Atualiza TODAS as barras (originais + clones sticky)
    var progressEls = document.querySelectorAll('[data-paternal-progress], .davila-paternal-progress--sticky');
    if (!progressEls.length) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        progressEls.forEach(function (el) {
          updateProgressBar(el, cart.total_price || 0);
        });
      })
      .catch(function () { /* silent */ });
  }

  function setupStickyProgress() {
    var progressEls = document.querySelectorAll('[data-paternal-progress][data-progress-sticky="1"]');
    progressEls.forEach(function (original) {
      if (original.dataset.davilaStickyInit === '1') return;
      original.dataset.davilaStickyInit = '1';

      // Clona a barra e adiciona ao body
      var clone = original.cloneNode(true);
      clone.classList.add('davila-paternal-progress--sticky');
      clone.removeAttribute('data-progress-sticky');
      clone.removeAttribute('id');
      document.body.appendChild(clone);

      // Mostra/esconde clone com base na visibilidade da original
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Mostra clone quando a original sai do viewport (rolou pra baixo dela)
            var isVisible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            clone.classList.toggle('is-visible', isVisible);
          });
        }, { threshold: 0 });
        observer.observe(original);
      }
    });
  }

  function setupCartProgressListener() {
    if (!document.querySelector('[data-paternal-progress]')) return;

    var CART_URL_REGEX = /\/cart\/(add|update|change|clear)/i;

    // Intercepta fetch
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var promise = originalFetch.apply(this, arguments);
      if (CART_URL_REGEX.test(urlStr)) {
        promise.then(function () { setTimeout(fetchCartAndUpdate, 150); });
      }
      return promise;
    };

    // Intercepta XMLHttpRequest (pra catch carrinhos que não usam fetch)
    var OriginalXHR = window.XMLHttpRequest;
    if (OriginalXHR && OriginalXHR.prototype) {
      var originalOpen = OriginalXHR.prototype.open;
      OriginalXHR.prototype.open = function (method, url) {
        if (typeof url === 'string' && CART_URL_REGEX.test(url)) {
          this.addEventListener('load', function () {
            setTimeout(fetchCartAndUpdate, 150);
          });
        }
        return originalOpen.apply(this, arguments);
      };
    }

    // Eventos custom de Shopify/Dawn/D'Avila
    document.addEventListener('cart:updated', fetchCartAndUpdate);
    document.addEventListener('cart:refresh', fetchCartAndUpdate);
    document.addEventListener('cart-drawer:opened', fetchCartAndUpdate);

    // Re-sincroniza ao voltar pra aba
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) fetchCartAndUpdate();
    });

    // Polling de seguranca: a cada 3s nos primeiros 12s apos um click em qualquer
    // botao do tipo "add" — captura cases onde nem fetch nem XHR foram interceptados
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[name="add"], [data-davila-quickadd], .product-form__submit, [data-product-add]');
      if (!addBtn) return;
      var attempts = 0;
      var poll = setInterval(function () {
        fetchCartAndUpdate();
        attempts++;
        if (attempts >= 4) clearInterval(poll);
      }, 3000);
      setTimeout(fetchCartAndUpdate, 500);
    });
  }

  function init() {
    setupSmoothScroll();
    setupScrollSpy();
    setupStickyProgress();
    setupCartProgressListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* trigger 1780965557 */
